/**
 * The invitation's "reply by" date. The couple picks a day, but the deadline
 * arrives as an instant, and older ones hold the couple's local midnight
 * (21:00Z the day before, in Greece): formatted in a guest's own time zone,
 * a guest abroad would read a day early. So the date shown is the day the
 * deadline means — the UTC midnight nearest it, the API's reading
 * (api/utils/rsvpDeadline.mjs) — formatted as that calendar day everywhere.
 * Held to the API's answers by app/src/utils/rsvpDeadline.test.mjs.
 */

const DAY_MS = 86400000;

/** The day a deadline means, as YYYY-MM-DD, or null. */
export const rsvpDeadlineDay = (value) => {
  if (!value) return null;
  const ms = new Date(value).getTime();
  if (Number.isNaN(ms)) return null;
  return new Date(Math.round(ms / DAY_MS) * DAY_MS).toISOString().slice(0, 10);
};

/** Editorial, warm: "Sunday, 14 June 2026". Empty when there is no deadline. */
export const formatDeadline = (value, locale) => {
  const day = rsvpDeadlineDay(value);
  if (!day) return "";
  return new Date(`${day}T00:00:00Z`).toLocaleDateString(locale || undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
};
